import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgAmex = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 28 18"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <rect width={27.5} height={17} x={0.25} y={0.5} fill="#006FCF" rx={2} />
      <text
        x={14}
        y={11.6}
        fill="#FFF"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize={6}
        fontWeight={700}
        letterSpacing={0.2}
        textAnchor="middle"
      >
        {"AMEX"}
      </text>
    </svg>
  );
};
export default SvgAmex;
